/* Nebula Candle Co. — custom sections behaviour (no dependencies) */
(function () {
'use strict';
if (window.__nebulaLoaded) return;
window.__nebulaLoaded = true;
function money(cents, format) {
var value = (cents / 100).toFixed(2);
if (format && format.indexOf('{{') > -1) {
return format.replace(/\{\{\s*\w+\s*\}\}/, value);
}
return '$' + value;
}
function initMood(root) {
var tabs = root.querySelectorAll('[data-nb-mood-tab]');
var cards = root.querySelectorAll('[data-nb-moods]');
var line = root.querySelector('[data-nb-mood-line]');
tabs.forEach(function (tab) {
tab.addEventListener('click', function () {
var mood = tab.getAttribute('data-nb-mood-tab');
tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
if (line) line.textContent = tab.getAttribute('data-nb-mood-line') || '';
cards.forEach(function (card) {
var moods = (card.getAttribute('data-nb-moods') || '').split(',');
card.hidden = !(mood === 'all' || moods.indexOf(mood) > -1);
});
});
});
}
function updateShipBars(totalCents) {
document.querySelectorAll('[data-nb-ship]').forEach(function (el) {
var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 5000;
var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
var bar = el.querySelector('.nb-ship__bar');
var msg = el.querySelector('.nb-ship__msg');
if (bar) bar.style.width = pct + '%';
if (msg) {
if (totalCents >= threshold) {
msg.textContent = el.getAttribute('data-done');
} else if (totalCents === 0) {
msg.textContent = el.getAttribute('data-empty');
} else {
msg.textContent = (el.getAttribute('data-away') || '').replace('[amount]', money(threshold - totalCents, el.getAttribute('data-money')));
}
}
});
}
function refreshCart() {
if (!document.querySelector('[data-nb-ship]')) return;
fetch('/cart.js', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (cart) {
updateShipBars(cart.total_price);
document.querySelectorAll('cart-icon').forEach(function (el) { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(cart.item_count, false); });
})
.catch(function () {});
}
function initProduct(root) {
var form = root.querySelector('form[action*="/cart/add"]');
var dataEl = root.querySelector('[data-nb-variants]');
var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
var moneyFormat = root.getAttribute('data-money-format');
var priceEl = root.querySelector('[data-nb-price]');
var compareEl = root.querySelector('[data-nb-compare]');
var atc = root.querySelector('[data-nb-atc]');
var atcLabel = root.querySelector('[data-nb-atc-label]');
var selectedName = root.querySelector('[data-nb-selected]');
var stickyVariant = document.querySelector('[data-nb-sticky-variant]');
var qtyInput = root.querySelector('[data-nb-qty]');
var mainImg = root.querySelector('[data-nb-main-img]');
var thumbs = root.querySelectorAll('[data-nb-thumb]');
var errorEl = root.querySelector('[data-nb-error]');
function showMedia(btn) {
if (!btn || !mainImg) return;
mainImg.src = btn.getAttribute('data-src');
mainImg.srcset = btn.getAttribute('data-srcset') || '';
mainImg.alt = btn.getAttribute('data-alt') || '';
thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
}
thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });
root.querySelectorAll('[data-nb-qty-step]').forEach(function (b) {
b.addEventListener('click', function () {
var v = parseInt(qtyInput.value, 10) || 1;
v = Math.max(1, Math.min(99, v + parseInt(b.getAttribute('data-nb-qty-step'), 10)));
qtyInput.value = v;
setLabel();
});
});
if (qtyInput) qtyInput.addEventListener('change', setLabel);
function current() {
var checked = root.querySelector('input[name="id"]:checked');
var id = checked ? parseInt(checked.value, 10) : (form && form.querySelector('[name="id"]') ? parseInt(form.querySelector('[name="id"]').value, 10) : null);
for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
return variants[0];
}
function setLabel() {
var v = current();
if (!v || !atc) return;
var q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
if (!v.available) {
atc.disabled = true;
atcLabel.textContent = atc.getAttribute('data-sold-out');
} else {
atc.disabled = false;
atcLabel.textContent = atc.getAttribute('data-add') + ' · ' + money(v.price * q, moneyFormat);
}
}
function onVariant() {
var v = current();
if (!v) return;
if (priceEl) priceEl.textContent = money(v.price, moneyFormat);
if (compareEl) {
compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, moneyFormat) : '';
}
if (selectedName) selectedName.textContent = v.title;
if (stickyVariant) stickyVariant.textContent = v.title + ' · ' + money(v.price, moneyFormat);
root.querySelectorAll('[data-nb-feel]').forEach(function (f) { f.hidden = f.getAttribute('data-nb-feel') !== v.title; });
if (v.featured_media_id) {
var t = root.querySelector('[data-nb-thumb][data-media-id="' + v.featured_media_id + '"]');
if (t) showMedia(t);
}
setLabel();
if (window.history && window.history.replaceState) {
var url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
}
}
root.querySelectorAll('input[name="id"]').forEach(function (r) { r.addEventListener('change', onVariant); });
onVariant();
if (form) {
form.addEventListener('submit', function (e) {
if (!window.fetch) return;
e.preventDefault();
if (errorEl) errorEl.textContent = '';
atc.disabled = true;
fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
.then(function (res) {
if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
atcLabel.textContent = atc.getAttribute('data-added');
document.dispatchEvent(new CustomEvent('nebula:cart-updated', { detail: res.body }));
refreshCart();
var goCart = root.getAttribute('data-after-add') === 'cart';
if (goCart) { window.location.href = '/cart'; return; }
setTimeout(function () { atc.disabled = false; setLabel(); }, 1800);
})
.catch(function (err) {
if (errorEl) errorEl.textContent = err.message;
atc.disabled = false;
});
});
}
var sticky = document.querySelector('[data-nb-sticky-add]');
if (sticky && form) sticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
}
function initRecs(el) {
var url = el.getAttribute('data-url');
if (!url) return;
fetch(url)
.then(function (r) { return r.text(); })
.then(function (html) {
var tmp = document.createElement('div');
tmp.innerHTML = html;
var inner = tmp.querySelector('[data-nb-recs]');
if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
})
.catch(function () {});
}
function init(scope) {
(scope || document).querySelectorAll('[data-nb-mood]').forEach(initMood);
(scope || document).querySelectorAll('[data-nb-product]').forEach(initProduct);
(scope || document).querySelectorAll('[data-nb-recs-target]').forEach(initRecs);
refreshCart();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
else init();
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
document.addEventListener('nebula:cart-updated', refreshCart);
})();
